import {commitMutation, graphql} from 'react-relay';
import {ConnectionHandler} from 'relay-runtime';
import environment from '../data/environment';

const mutation = graphql`
  mutation CreateReportMutation(
    $input: CreateReportInput!
  ) {
    createReport(input: $input) {
      report {
        id
        mongoId
        name
      }
    }
  }
`;

function commit({name}) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          name,
        },
      },
      updater: (store) => {
        const payload = store.getRootField('createReport');
        const newReport = payload.getLinkedRecord('report');
        const connection = ConnectionHandler.getConnection(
          store.getRoot(),
          'ReportList_reports',
        );
        const newEdge = ConnectionHandler.createEdge(
          store,
          connection,
          newReport,
          'ReportEdge',
        );
        ConnectionHandler.insertEdgeBefore(connection, newEdge);
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/CreateReportMutation.js